export function hamburger() {
  const hamburgerBtn = document.querySelector('.js-hamburgerBtn');
  const hamburgerNav = document.querySelector('.js-hamburgerNav');
  const hamburgerNav_link = document.querySelectorAll('.js-hamburgerNav_link');

  hamburgerBtn.addEventListener('click', () => {
    hamburgerBtn.classList.toggle('is-active');
    hamburgerNav.classList.toggle('is-active');
  });

  hamburgerNav_link.forEach(link => {
    link.addEventListener('click', () => {
      hamburgerBtn.classList.remove('is-active');
      hamburgerNav.classList.remove('is-active');
    })
  });
}